export default {
      id: "btn-shape--border-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape--border-usage",
      toString: function () {
        return this.url;
      }
    }